import { render, staticRenderFns } from "./BaseInfoEdit.vue?vue&type=template&id=a7fcd8a6&scoped=true"
import script from "./BaseInfoEdit.vue?vue&type=script&lang=js"
export * from "./BaseInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoEdit.vue?vue&type=style&index=0&id=a7fcd8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fcd8a6",
  null
  
)

export default component.exports